export default "__VITE_PUBLIC_ASSET__0b416c25__"